import React from 'react';
import { Globe } from 'lucide-react';
import MenuPageShell from '../MenuPageShell';
import InfoCard from '../InfoCard';

const AboutPage = ({ onBack }) => (
  <MenuPageShell title='關於 EC Travel' icon={Globe} onBack={onBack}>
    <InfoCard head='我們的故事' text='EC Travel 於 2026 年創立，致力以科技讓旅遊變得更簡單、更有趣、更方便。'/>
    <InfoCard head='我們的使命' text='結合 AI 技術與真實旅遊數據，為每位旅客提供個人化的行程建議、即時優惠及無縫預訂體驗。'/>
    <InfoCard head='我們的團隊' text='是一位熱愛旅遊的打工仔。'/>
  </MenuPageShell>
);

export default AboutPage;
